module.exports = __webpack_public_path__ + "img/refer.0ef28d06.png";